import React, { Fragment, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import cx from 'classnames';
import toNumber from 'lodash/toNumber';
import {
  Grid,
  IconButton,
  TableContainer,
  Table,
  TableBody,
  Typography,
  withStyles,
  Button,
} from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import { number, shape, string, func, bool } from 'prop-types';

import styles from './styles';
import { getI18n } from '../../../../utils/intl';
import { PROXY_DISCONNECTED } from '../../../../constants';
import {
  OverviewPaper,
  OverviewPaperWithStatusTableHead,
  OverviewPaperWithStatusTableRow,
} from './Paper';

export const Plans = (props) => {
  const {
    classes,
    id,
    title,
    subTitle,
    proxyStatus,
    portalPlanCounts,
    gatewayPlanCounts,
    lastUpdated,
    onDeployRateLimit,
    isDeployRateLimitDisabled,
    onRateLimitDeployTimerExpiry,
  } = props;

  const intl = getI18n(useIntl());
  const arePlanCountsEqual = (
    toNumber(portalPlanCounts) === toNumber(gatewayPlanCounts)
  );
  const [isDeploy, setIsDeploy] = useState(false);
  const [timer, setTimer] = useState(10);

  const onClickDeploy = () => {
    setIsDeploy(true);
    onDeployRateLimit();
  }

  useEffect(() => {
   let interval = null;
    if (isDeploy) {
      interval = setInterval(() => {
        setTimer(timer - 1);
        if (timer === 1) {
          setTimer(10);
          onRateLimitDeployTimerExpiry();
          setIsDeploy(false);
          clearInterval(interval);
        }
      }, 1000);
    } else {
      setTimer(10);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isDeploy, timer])

  const DepolymentButton = () =>
    <Button
      variant={isDeploy ? "contained" : "outlined"}
      color={"secondary"}
      disabled={isDeployRateLimitDisabled || isDeploy || (proxyStatus === PROXY_DISCONNECTED)}
      onClick={onClickDeploy}
      id={`${id}-deploy-button`}
      data-apim-test={`${id}-deploy-button`}
      data-layer7-test={`${id}-deploy-button`}
    >
      {isDeploy ?
        intl.getI18nFormattedMessage('label.proxy.details.rate.quota.deploying')
        : intl.getI18nFormattedMessage('label.proxy.details.rate.quota.deployment')
      }
      {isDeploy ? timer : ''}
    </Button>

  return (
    <>
      {arePlanCountsEqual ?
        <OverviewPaper
          id={id}
          title={title}
          subTitle={subTitle}
          proxyStatus={proxyStatus}
          content={portalPlanCounts}
          lastUpdated={lastUpdated}
          deployButton={<DepolymentButton />}
        /> :
        <OverviewPaper
          id={id}
          title={title}
          subTitle={subTitle}
          proxyStatus={proxyStatus}
          contentMore={
            <Fragment>
              <TableContainer>
                <Table size="small">
                  <OverviewPaperWithStatusTableHead
                    rowName={intl.getI18nMessage('label.proxy.details.page.source')}
                    cells={[
                      {
                        key: 'published',
                        value: intl.getI18nMessage('label.proxy.details.page.status.published'),
                      },
                    ]}
                  />
                  <TableBody>
                    <OverviewPaperWithStatusTableRow
                      rowName={intl.getI18nMessage('label.proxy.details.api.portal')}
                      cells={[
                        { key: `portal.plan.counts.${id}`, value: portalPlanCounts },
                      ]}
                    />
                    <OverviewPaperWithStatusTableRow
                      rowName={intl.getI18nMessage('label.proxy.details.api.gateway')}
                      cells={[
                        { key: `gateway.plan.counts.${id}`, value: gatewayPlanCounts },
                      ]}
                    />
                  </TableBody>
                </Table>
              </TableContainer>
              <Grid container style={{ marginTop: 25, marginBottom: 25 }}>
                <Grid item>
                  <IconButton className={cx(classes.icon, classes.countMismatch)}>
                    <WarningIcon />
                  </IconButton>
                </Grid>
                <Grid item>
                  <Typography variant="body1">
                    {intl.getI18nMessage('label.proxy.details.portal.gateway.counts.different')}
                  </Typography>
                </Grid>
              </Grid>
            </Fragment>
          }
          lastUpdated={lastUpdated}
          deployButton={<DepolymentButton />}
        />
      }
    </>
  );
};

Plans.propTypes = {
  classes: shape({}),
  id: string,
  title: string,
  subTitle: string,
  proxyStatus: string,
  portalPlanCounts: number,
  gatewayPlanCounts: number,
  lastUpdated: string,
  onDeployRateLimit: func,
  onRateLimitDeployTimerExpiry: func,
  isDeployRateLimitDisabled: bool,
};
Plans.displayName = 'Plans';

export default (
  withStyles(styles)
)(Plans);
